// src/utilities/apiPaths.js
// API paths

export const wcBaseUrl = "https://www.wolframcloud.com/obj/mitch/"
export const wcEndPoint = "ch/api/test/"